function initScoutTemplateOfferSelectModal() {
  const modal = document.querySelector('.js-modal-basic[data-modalid="scout_template_offer_select"]');
  if (!modal) return;

  const searchInput = modal.querySelector('[data-js-offer-search]');
  const submitBtn = modal.querySelector('[data-js-offer-submit]');
  const offerList = modal.querySelector('[data-js-offer-list]');

  let searchTimeout;

  function setSubmitEnabled(enabled) {
    if (!submitBtn) return;
    submitBtn.disabled = !enabled;
    submitBtn.classList.toggle('is-disabled', !enabled);
  }

  function fetchOffers(query) {
    const url = `/manage/templates/scouts/search_offers?q=${encodeURIComponent(query)}`;
    fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(res => res.text())
      .then(html => {
        if (offerList) offerList.innerHTML = html;
        // 一覧再描画で選択状態が消えるため、ボタンも未選択状態に戻す
        setSubmitEnabled(false);
      })
      .catch(err => console.error('Error searching offers:', err));
  }

  searchInput?.addEventListener('input', () => {
    clearTimeout(searchTimeout);
    const query = searchInput.value.trim();
    searchTimeout = setTimeout(() => fetchOffers(query), 300);
  });

  modal.addEventListener('click', e => {
    if (!e.target.closest('.js-modal-basic-close, .js-modal-basic-overlay')) return;
    if (!searchInput || searchInput.value === '') return;
    searchInput.value = '';
    clearTimeout(searchTimeout);
    fetchOffers('');
  });

  modal.addEventListener('change', e => {
    if (!e.target.matches('[data-js-offer-selection]')) return;
    const anyChecked = [...modal.querySelectorAll('[data-js-offer-selection]')].some(r => r.checked);
    setSubmitEnabled(anyChecked);
  });

  // 選択した求人をフォームコントローラに連携する。
  // 保存リクエストのボディは Stimulus コントローラの offeridValue から組み立てられるため、
  // hidden input を直接書き換える経路はリクエストに反映されない。コントローラを取得できなかった
  // 場合は連携失敗として false を返し、呼び出し側でモーダルを閉じないようにする。
  function syncSelectedOffer(selected) {
    const formEl = document.getElementById('scout_template_form');
    if (!formEl || !window.Stimulus) {
      console.error('Failed to sync offer selection: scout template form element or Stimulus is not available.');
      return false;
    }
    const formController = window.Stimulus.getControllerForElementAndIdentifier(formEl, 'scout-template-form-v3')
      || window.Stimulus.getControllerForElementAndIdentifier(formEl, 'scout-template-form-v2');
    if (!formController || typeof formController.offeridValueHandler !== 'function') {
      console.error('Failed to sync offer selection: scout template form controller was not found.');
      return false;
    }
    const sourceLabel = selected.parentElement.querySelector('label.c-block-54');
    const cardHtml = sourceLabel ? sourceLabel.innerHTML : null;
    formController.offeridValueHandler(selected.value, selected.dataset.offerTitle || '', cardHtml);
    return true;
  }

  submitBtn?.addEventListener('click', e => {
    const selected = modal.querySelector('[data-js-offer-selection]:checked');
    if (!selected) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    if (!syncSelectedOffer(selected)) {
      // 連携失敗時はモーダルを閉じない（js-modal-basic-close の発火を抑止する）
      e.preventDefault();
      e.stopPropagation();
      return;
    }

  });
}

document.addEventListener('DOMContentLoaded', initScoutTemplateOfferSelectModal);
